// header.php sets window.BASE_URL from get_site_url() at runtime; VUE_APP_HOSTNAME is only for `yarn serve`.
const API_HOST = window.BASE_URL ? window.BASE_URL : (process.env.VUE_APP_HOSTNAME ? process.env.VUE_APP_HOSTNAME : window.location.origin)
const GA_ID = window.GA_ID ? window.GA_ID : process.env.VUE_APP_GA_ID
const GTM_ID = window.GTM_ID ? window.GTM_ID : process.env.VUE_APP_GTM_ID

export const TITLE = window.TITLE ? window.TITLE : process.env.VUE_APP_TITLE

export { GA_ID, GTM_ID, API_HOST }
